/* @ngInject */
function GuestApprovalStatusCardController ($translate) {
  const ctrl = this

  ctrl.statusTitle = ''
  ctrl.statusDescription = ''

  ctrl.defineStatus = function (status) {
    ctrl.statusTitle = ''
    ctrl.statusDescription = ''

    switch (status) {
      case 'APPROVED':
        ctrl.statusTitle = $translate.instant('guestApprovedRequest')
        ctrl.statusDescription = $translate.instant('guestApprovedRequestDescription')
        return 'done'
      case 'ADJUST':
        ctrl.statusTitle = $translate.instant('waitingAdjusts')
        ctrl.statusDescription = $translate.instant('guestWaitingAdjustsDescription')
        return 'adjustments'
      case 'REJECTED':
        ctrl.statusTitle = $translate.instant('guestRejectedRequest')
        ctrl.statusDescription = $translate.instant('guestRejectedRequestDescription')
        return 'warning-paper'
    }
  }
}

export { GuestApprovalStatusCardController }
